import { render, staticRenderFns } from "./ServiceWarehouseItems.vue?vue&type=template&id=eda75ff0&"
import script from "./ServiceWarehouseItems.vue?vue&type=script&lang=js&"
export * from "./ServiceWarehouseItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports